import { render } from 'storyblok-rich-text-react-renderer';

function HeadlineWithRichtext({ document, blok }) {
    document = blok.richtext
    // in the form { type: "doc", content: [ ... ] }
    return (
    <div className='headlinewithrichtext-wrap'>
        <h2 className='text-2xl headlinewithrichtext-headline'>{blok.subheadline}</h2>
        <div className='headlinewithrichtext-text' suppressHydrationWarning>{render(document)}</div>
        </div>);
}

export default HeadlineWithRichtext;